module.exports = __webpack_public_path__ + "img/profil_lapper_bjørg-nina.ac83a399.png";